module.exports = __webpack_public_path__ + "media/svgs/smiley-xx-249a969aeb0fd281fe1f914a4ba5e12e.svg";